module.exports = __webpack_public_path__ + "img/tn-timeline-misc-9.dd6c8eb9.jpg";